module.exports = __webpack_public_path__ + "img/2023big16.c10a2fe3.png";